<div class="map-over" *ngIf="url">
  <iframe class="map" width="100%" width="100%" [src]="url | safe" target="_parent"></iframe>
</div>
